import { PlatformSubSection } from "@tracabois/template"
import { MarkdownField } from "@komune-io/g2-forms"
import { Box, Typography } from "@mui/material"

const MAX_DESCRIPTION_LENGTH = 5000

interface RealizationDescriptionSectionProps {
  description: string
  onChange: (description: string) => void
  readOnly?: boolean
  title: string
}

export const RealizationDescriptionSection = (props: RealizationDescriptionSectionProps) => {
  const { description, onChange, readOnly = false, title } = props

  return (
    <PlatformSubSection title={title}>
      <Box
        sx={{
          '& .mdxeditor': {
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            overflow: 'hidden',
          },
          '& .mdxeditor [role="toolbar"]': {
            borderBottom: '1px solid',
            borderColor: 'divider',
            px: 1,
            py: 0.5,
          },
          '& .mdxeditor div[contenteditable="true"]': {
            minHeight: 120,
            px: 2,
            py: 1,
          },
        }}
      >
        <MarkdownField
          markdown={description}
          readOnly={readOnly}
          onChange={onChange}
        />
        <Typography
          variant="caption"
          color={description.length > MAX_DESCRIPTION_LENGTH ? "error" : "text.secondary"}
          sx={{ display: "block", textAlign: "right", mt: 0.5 }}
        >
          {description.length}/{MAX_DESCRIPTION_LENGTH}
        </Typography>
      </Box>
    </PlatformSubSection>
  )
}
